module.exports = __webpack_public_path__ + "static/SpaceShip-9cb93460d1165409dc154f499fc93a63.mp4";